interface MonthlyWarriorTeaserProps {
  warriorNumber: number;
  className?: string;
}

export function MonthlyWarriorTeaser({
  warriorNumber,
  className = '',
}: Readonly<MonthlyWarriorTeaserProps>): JSX.Element {
  return (
    <div
      className={`rounded-lg border border-teal-200 bg-teal-50 px-4 py-3 text-left ${className}`.trim()}
    >
      <p className="text-base font-semibold text-teal-900">
        You are now Warrior #{warriorNumber}. Welcome to the circle.
      </p>
      <p className="mt-1 text-sm text-teal-900/90">
        Your monthly gift joins a growing community of supporters funding lifesaving dialysis care.
      </p>
    </div>
  );
}
